import type { Category } from '@inference.engine/guidelines';
import { i18n } from '@/shared/i18n';
import { categoricalBadgeClass, type CategoricalBadgeColor } from '@/shared/ui/categoricalBadge';

// The `Category` token is persisted and compared, so only the label is keyed —
// deriving the label from the token again would translate the value with it.
const CATEGORY_LABEL_KEYS = {
  BrandAssets: 'knowledge:guidelines.category.brandAssets',
  ContentStyle: 'knowledge:guidelines.category.contentStyle',
  TextCorrectness: 'knowledge:guidelines.category.textCorrectness',
  TextFormatting: 'knowledge:guidelines.category.textFormatting',
  TechnicalRequirements: 'knowledge:guidelines.category.technicalRequirements',
} as const satisfies Record<Category, string>;

export const formatCategoryLabel = (category?: Category): string =>
  category ? i18n.t(CATEGORY_LABEL_KEYS[category]) : '';

const CATEGORY_BADGE_COLORS = {
  BrandAssets: 'green',
  ContentStyle: 'blue',
  TextCorrectness: 'orange',
  TextFormatting: 'pink',
  TechnicalRequirements: 'lightBlue',
} as const satisfies Record<Category, CategoricalBadgeColor>;

export const getCategoryBadgeClass = (category: Category): string =>
  categoricalBadgeClass(CATEGORY_BADGE_COLORS[category]);
